// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ArticlePage from './pages/ArticlePage';
import ArticlesListing from './pages/ArticlesListing';
import CalculatorPage from './pages/CalculatorPage';
import CalculatorsListing from './pages/CalculatorsListing';
import SearchPage from './pages/SearchPage';
import AboutUs from './pages/AboutUs';
import AnimatedBackground from './components/AnimatedBackground';

function App() {
  return (
    <Router>
      <div className="App min-h-screen selection:bg-brand/30 selection:text-brand">
        <AnimatedBackground />

        <Header />
        <main className="relative max-w-7xl mx-auto px-6 pt-32 pb-20">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/articles" element={<ArticlesListing />} />
            <Route path="/articles/:slug" element={<ArticlePage />} />
            <Route path="/calculators" element={<CalculatorsListing />} />
            <Route path="/calculators/:slug" element={<CalculatorPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/aboutus" element={<AboutUs />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;